// extracted by mini-css-extract-plugin
export default {"wrap":"ow-z","logoContainer":"pw-z","brandImg":"qw-z","logoImg":"rw-z","logoButton":"sw-z"};